import { Labels } from '../types';

export const daLabels: Labels = {
  // Navigation & Header
  appTitle: 'AGENTDAGEN\'s Nyhedsagent',
  appSubtitle: 'Din simple AI agent til at holde øje med de vigtigste nyheder',
  profile: 'Profil',
  logout: 'Log ud',
  backToChat: 'Tilbage til chat',
  mainAgent: 'AGENTDAGEN’s Nyhedsagent',
  
  // Authentication
  login: 'Log ind',
  email: 'E-mailadresse',
  password: 'Adgangskode',
  confirmPassword: 'Bekræft adgangskode',
  forgotPassword: 'Glemt adgangskode?',
  createAccount: 'Opret konto',
  alreadyHaveAccount: 'Har du allerede en konto? Log ind',
  backToLogin: 'Tilbage til login',
  signUp: 'Tilmeld dig',
  sendResetLink: 'Send nulstillingslink',
  
  // Common
  loading: 'Indlæser...',
  cancel: 'Annuller',
  save: 'Gem',
  delete: 'Slet',
  edit: 'Rediger',
  back: 'Tilbage',
  
  // Profile
  profileSettings: 'Profilindstillinger',
  profileSubtitle: 'Administrer dine kontoindstillinger og præferencer',
  personalInformation: 'Personlige oplysninger',
  displayName: 'Visningsnavn',
  emailAddress: 'Email adresse',
  emailCannotBeChanged: 'Email kan ikke ændres',
  updateProfile: 'Opdater profil',
  deleteAccount: 'Slet konto',
  deleteAccountWarning: 'Når du sletter din konto, er der ingen vej tilbage. Vær sikker.',
  deleteAccountConfirm: 'Slet konto',
  deleteAccountConfirmText: 'Er du sikker på, at du vil slette din konto? Denne handling kan ikke fortrydes.',
  dangerZone: 'Farezone',
  
  // Chat
  typeMessageHere: 'Skriv din besked her...',
  processing: 'Behandler din anmodning...',
  suggestedSearches: 'Foreslåede søgninger:',
  searchSuggestion1: 'Hvad er de nyeste trends indenfor AI agenter?',
  searchSuggestion2: 'Hvilke virksomheder i Europa er lige nu førende indenfor AI agenter?',
  searchSuggestion3: 'Hvad forventer ekspert af trends på området det næste år?',
  
  // Message Filters

  
  // Email Verification
  verifyEmailMessage: 'Bekræft venligst din email adresse. Tjek din indbakke for et bekræftelseslink.',
  
  // Messages
  resetPasswordMessage: 'Hvis der findes en konto for denne email, er et link til nulstilling af kodeord sendt.',
  sessionExpiredMessage: 'Din session er udløbet, eller du er ikke logget ind. Log venligst ind igen.',
  notAuthenticatedMessage: 'Du er ikke logget ind.',
  verifyEmailAccessMessage: 'Bekræft venligst din email adresse for at få adgang til denne side.',
  
  // Language
  language: 'Sprog',
  english: 'Engelsk',
  danish: 'Dansk',
  
  // Agent Role Names
  userRole: 'Dig',
  mainAgentRole: 'AGENTDAGEN’s Nyhedsagent',
  planningAgentRole: 'Planlægningsagent',
  researchAgentRole: 'Søgeagent',
  storageAgentRole: 'Lagringsagent',
  agentRole: 'Agent',
  unknownAgent: 'Ukendt',
  
  // Agent Status Messages
  analyzingRequest: 'Analyserer din anmodning...',
  planningResearch: 'Planlægger søgestrategi...',
  conductingResearch: 'Udfører søgning...',
  storingQuery: 'Gemmer din søgeplan...',
  
  // Yes/No buttons
  yes: 'Ja',
  no: 'Nej',
  
  // Initialization message
  initializationMessage: 'Hej! Præsenter dig selv og forklar, hvordan du kan hjælpe mig i dag. Mit foretrukne sprog er dansk, og dagens dato er {date}.',
  
  // Privacy
  privacyPolicy: 'Privatlivspolitik',
  privacyPolicySubtitle: 'Hvordan vi indsamler, bruger og beskytter dine oplysninger',
  privacyPolicyTitle: 'Privatlivspolitik',
  privacyPolicyContent: 'Denne Privatlivspolitik beskriver, hvordan AGENTDAGEN\'s News Agent indsamler, bruger og beskytter dine personlige oplysninger, når du bruger vores service. Ved at bruge vores service accepterer du indsamling og brug af oplysninger i overensstemmelse med denne politik.',
  dataCollectionTitle: 'Oplysninger vi indsamler',
  dataCollectionContent: 'Vi indsamler oplysninger, du giver os direkte, såsom dit navn, e-mailadresse og sprogpræferencer. Vi indsamler også oplysninger om din brug af vores service, herunder dine søgeforespørgsler og interaktioner med vores AI-agent.',
  dataUsageTitle: 'Hvordan vi bruger dine oplysninger',
  dataUsageContent: 'Vi bruger de oplysninger, vi indsamler, til at levere, vedligeholde og forbedre vores service, til at kommunikere med dig og til at personliggøre din oplevelse. Vi kan også bruge dine oplysninger til at udvikle nye funktioner og tjenester.',
  dataProtectionTitle: 'Databeskyttelse',
  dataProtectionContent: 'Vi implementerer passende sikkerhedsforanstaltninger for at beskytte dine personlige oplysninger mod uautoriseret adgang, ændring, offentliggørelse eller ødelæggelse. Dine data opbevares sikkert, og vi begrænser adgangen til dine personlige oplysninger til kun autoriseret personale.',
  contactInfoTitle: 'Kontaktoplysninger',
  contactInfoContent: 'Hvis du har spørgsmål til denne Privatlivspolitik eller vores datapraksis, bedes du kontakte os på privacy@agentdagen.com.',
  privacyAgreement: 'Privatlivsaftale',
  privacyAgreementText: 'Jeg accepterer',
  privacyAgreementLink: 'Privatlivspolitikken',
}; 